import React from 'react';
import {
  View, StyleSheet, Text, TextInput, Platform,
} from 'react-native';
import Colors from '../../../../constants/Colors';
import Style from '../../../../constants/Style';

type Section = {
  title: string,
  innerColor: string,
  outerColor: string,
  lowerLimit: number,
  upperLimit: number,
}

const SECTIONS: Section[] = [
  {
    title: 'Bad',
    innerColor: Colors.light.hereworksRed500,
    outerColor: Colors.light.hereworksRed50,
    lowerLimit: 1,
    upperLimit: 33,
  },
  {
    title: 'Moderate',
    innerColor: Colors.light.hereworksBlue500,
    outerColor: Colors.light.hereworksBlue50,
    lowerLimit: 34,
    upperLimit: 66,
  },
  {
    title: 'Good',
    innerColor: Colors.light.hereworksGreen500,
    outerColor: Colors.light.hereworksGreen50,
    lowerLimit: 66,
    upperLimit: 100,
  },
];

interface SectionItemProps {
  section: Section
}

const SectionItem = ({ section }: SectionItemProps) => <View>
  <View style={styles.row}>
    <View style={[styles.dot, { backgroundColor: section.outerColor }]}>
      <View style={[styles.dotCenter, { backgroundColor: section.innerColor }]} />
    </View>
    <Text style={styles.sectionTitle}>{section.title}</Text>
  </View>
  <View style={[styles.row, styles.inputContainer]}>
    <TextInput
      style={styles.input}
      value={section.lowerLimit.toString()}
      maxLength={3}
    />
    <View style={styles.dash} />
    <TextInput
      style={styles.input}
      value={section.upperLimit.toString()}
      maxLength={3}
    />
  </View>
</View>;

const ScoreSettings = () => <View style={styles.container}>
  <Text style={styles.parameterTitle}>OVERALL SCORE</Text>
  <View style={Style.row}>
    {SECTIONS.map((section: Section, index: number) => <SectionItem
      key={`section_item_${index}`}
      {...{ section }}
    />)}
  </View>
</View>;

const styles = StyleSheet.create({
  container: {
    backgroundColor: Colors.light.hereworksWhite200,
    borderColor: Colors.light.hereworksWhite500,
    borderWidth: 1,
    borderRadius: 8,
    padding: 16,
  },
  parameterTitle: {
    fontSize: 10,
    lineHeight: 15,
    fontFamily: 'Roboto_500Medium',
    color: Colors.light.hereworksBlack400,
    marginBottom: 12,
  },
  row: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  dot: {
    width: 16,
    aspectRatio: 1,
    borderRadius: 8,
    justifyContent: 'center',
    alignItems: 'center',
  },
  dotCenter: {
    width: 8,
    aspectRatio: 1,
    borderRadius: 4,
  },
  sectionTitle: {
    fontSize: 14,
    lineHeight: 16,
    fontFamily: 'Poppins_600SemiBold',
    color: Colors.light.hereworksBlack600,
  },
  inputContainer: {
    marginTop: 8,
  },
  input: {
    padding: 8,
    borderRadius: 5,
    backgroundColor: '#FFF',
    width: 44,
    aspectRatio: 1,
    fontSize: 16,
    lineHeight: Platform.OS === 'ios' ? undefined : 24,
    fontFamily: 'Roboto_400Regular',
    color: Colors.light.hereworksBlack600,
    textAlign: 'center',
  },
  dash: {
    height: 1,
    width: 8,
    marginHorizontal: 8,
    backgroundColor: '#000',
  },
});

export default ScoreSettings;
